import FoundryDropdown from 'src/components/general/foundry-dropdown/'
import { mapGetters } from 'vuex'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import Misc from 'src/utils/helper/misc'
import { errors as submissionErrors } from 'src/pages/submissions/script/common.data'
export default {
  name: 'submission-foundry-dd',

  data () {
    return {
      ready: {
        name: this.$options.name,
        state: 'unset'
      },
      submissionPermissionFoundries: [],
    }
  },

  components: {
    FoundryDropdown
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('profile', {
      foundries: ['foundries'],
      defaultFoundry: ['defaultFoundry']
    })
  },
  methods: {
    ...Misc,
    ...SubmissionMethods,
    checkPermissionForSessionFoundry (foundryId) {
      let present = false
      this.foundries.forEach(foundry => {
        if (foundry.id === foundryId) {
          if (foundry.permissions) {
            foundry.permissions.forEach(per => {
              let rolesObj = this.getRoleIdMapping()
              if (rolesObj['agreements'] === per.id) {
                present = true
                this.$store.commit('profile/setAgreementFoundryPermission', true)
              }
            })
          }
        }
        if (!present) {
          this.$store.commit('profile/setAgreementFoundryPermission', false)
          setTimeout(() => {
            this.$store.commit('profile/setAgreementFoundryPermission', true)
           }, 8000)
        }
      })
    },
    getFoundry (foundry) {
      if (foundry) {
        const foundryOnUser = this.foundries.find(userFoundry => userFoundry.id === foundry.value)
        const credibility = foundryOnUser.hasOwnProperty('credibility') ? foundryOnUser.credibility : 'Unknown'
        this.submissionFoundry = { foundryId: foundry.value, name: foundry.label, credibility: credibility }
        this.submissionVendor = { vendorId: foundry.value, name: foundry.label }
        if (foundry.value !== window.localStorage.getItem('sessionFoundryId')) {
          this.$store.dispatch('auth/setSessionFoundry', {id: foundry.value, name: foundry.label})
          this.checkPermissionForSessionFoundry(foundry.value)
          this.updateSubmission()
          this.$store.dispatch('submissions/resetFamilyGroup')
          this.$events.$emit('family-group:update')
        }
      }
    },
    filteredFoundries() {
      this.submissionPermissionFoundries = this.foundries.filter(foundry => {
        if (foundry.permissions) {
          return foundry.permissions.some(per => {
            let rolesObj = this.getRoleIdMapping()
            return rolesObj['submissions'] === per.id
          })
        }
        return false
      })
    },
  },
  created () {
    this.$store.dispatch('profile/getFoundries').then((res) => {
      this.ready.state = 'set'
      const sessionFoundryId = window.localStorage.getItem('sessionFoundryId')
      this.checkPermissionForSessionFoundry(sessionFoundryId);
      this.filteredFoundries();
    })

    this.$events.$on('get_selectedFoundry', (val) => {
      if (submissionErrors.value && Array.isArray(submissionErrors.value)) {
        submissionErrors.value = submissionErrors.value.filter(
          error => !Object.hasOwn(error, 'Foundry')
        )
      }
    })
  }
}
